<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_22583_33804)">
      <path
        d="M6.07326 20.9698C5.79195 20.9698 5.52216 20.858 5.32324 20.6591C5.12433 20.4602 5.01258 20.1904 5.01258 19.9091L5.00196 5.54514C4.98919 5.22942 5.03896 4.9143 5.14841 4.61788C5.25786 4.32147 5.42484 4.04962 5.63973 3.81797C5.85462 3.58632 6.11319 3.39944 6.40057 3.26808C6.68794 3.13672 6.99845 3.06347 7.31424 3.05255L17.4861 2.99951C17.8023 3.00503 18.1144 3.0728 18.4044 3.19893C18.6944 3.32506 18.9567 3.50709 19.1764 3.73462C19.396 3.96214 19.5687 4.23072 19.6845 4.52499C19.8004 4.81926 19.8571 5.13348 19.8515 5.44968L19.8515 19.8136C19.8533 19.9995 19.8062 20.1826 19.715 20.3446C19.6238 20.5065 19.4916 20.6416 19.3317 20.7364C19.1705 20.8295 18.9876 20.8785 18.8014 20.8785C18.6152 20.8785 18.4323 20.8295 18.2711 20.7364L12.2252 17.3847L6.6142 20.8107C6.44805 20.9035 6.2632 20.9579 6.07326 20.9698Z"
        fill="#F08B71"
      />
    </g>
    <defs>
      <clipPath id="clip0_22583_33804">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 -0.000488281)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
